"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldEmitter = void 0;
const FieldEmitter = (emit, emitter, name, value) => {
    if (name && emitter) {
        const isArray = Array.isArray(emitter);
        if (isArray) {
            emitter.forEach((item) => {
                emit(`${name}-${item}`, value);
            });
        }
        else {
            if (emitter) {
                emit(`${name}-${emitter}`, value);
            }
            else {
                return;
            }
        }
    }
    else {
        return;
    }
};
exports.FieldEmitter = FieldEmitter;
